import React, { useMemo } from "react";
import DashboardLayout from "./DashboardLayout";
import DirectChat from "../components/DirectChat";

export default function AdminChatPage() {
  const actor = useMemo(() => {
    let user = {};
    try {
      user = JSON.parse(localStorage.getItem("user") || "{}");
    } catch (error) {
      user = {};
    }

    return {
      type: "admin",
      id: user.id ?? 0,
      name: user.name || user.admin_type || user.login_id || user.email || "Master Admin",
    };
  }, []);

  return (
    <DashboardLayout>
      <DirectChat actor={actor} title="New Message" />
    </DashboardLayout>
  );
}
